/**
 * Workbench (Build layer) — shared labels and helpers (brief v0.33).
 */

export const BUILD_ITEM_STATUSES = [
  { key: 'not_started', label: 'Not started' },
  { key: 'assignment_pending', label: 'Assignment pending' },
  { key: 'in_progress', label: 'In progress' },
  { key: 'done', label: 'Done' },
];

export const BUILD_ITEM_STATUS_LABEL = Object.fromEntries(
  BUILD_ITEM_STATUSES.map((s) => [s.key, s.label])
);

export const OOTB_CLASSIFICATION_LABEL = {
  ootb: 'OOTB',
  config: 'Config',
  enhancement: 'Enhancement',
  custom_dev: 'Custom Dev',
};

export const OOTB_TO_BUILD_TYPE = {
  ootb: 'OOTB',
  config: 'Config',
  enhancement: 'Enhancement',
  custom_dev: 'Enhancement',
};

export function ootbPillClass(classification) {
  if (classification === 'ootb') return 'ootb-ootb';
  if (classification === 'config') return 'ootb-config';
  if (classification === 'enhancement') return 'ootb-enhancement';
  return 'ootb-custom';
}

export function buildTypePillClass(typeName) {
  if (!typeName) return 'type-Config';
  const key = typeName.replace(/\s/g, '');
  return `type-${key}`;
}

export function buildStatusPillClass(status) {
  const map = {
    not_started: 'status-notstarted',
    assignment_pending: 'status-assignmentpending',
    in_progress: 'status-inprogress',
    done: 'status-done',
  };
  return map[status] || 'status-notstarted';
}

/** Suggest a build item type from requirement OOTB classification (Rex hint). */
export function suggestBuildTypeFromOotb(ootbClassification) {
  return OOTB_TO_BUILD_TYPE[ootbClassification] || 'Config';
}

export function initials(name) {
  if (!name) return '';
  return name.split(' ').map((p) => p[0]).join('').toUpperCase().slice(0, 2);
}

export function nextBuildItemRef(existingRefs) {
  const nums = (existingRefs || [])
    .map((r) => {
      const m = /^BI-(\d+)$/i.exec(r || '');
      return m ? parseInt(m[1], 10) : 0;
    })
    .filter((n) => n > 0);
  const next = (nums.length ? Math.max(...nums) : 0) + 1;
  return `BI-${String(next).padStart(3, '0')}`;
}

export const DELEGATING_ROLE_BY_TYPE = {
  Config: 'Configurator',
  Workflow: 'Configurator',
  Report: 'Developer',
  Interface: 'Technical Lead',
  Conversion: 'Data Migration Lead',
  Enhancement: 'Technical Lead',
  Form: 'Developer',
  'Data Migration': 'Data Migration Lead',
};
